import { CSSProperties } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import Logo from "../assets/ONLY RYAN FULL LOGO RED.png";

const Footer: React.FC = () => {
  return (
    <Container
      fluid
      style={{
        background: "whitesmoke",
        display: "flex",
        flexFlow: "column",
        padding: "50px",
      }}
    >
      <Container>
        <Row>
          <Col style={ColStyle} sm={12} md={3}>
            <label style={footerTitle}>Company</label>
            <a href="https://onlyryan.co.za/about">About</a>
          </Col>
          <Col style={ColStyle} sm={12} md={3}>
            <label style={footerTitle}>Platform</label>
            <a href="https://onlyryan.co.za/">Leaderboard</a>
          </Col>
          <Col style={ColStyle} sm={12} md={3}>
            <label style={footerTitle}>Account</label>
            <a href="https://account.onlyryan.co.za/">Player/Gamer Account</a>
            <a href="https://business.onlyryan.co.za/">Business Manager</a>
          </Col>
          <Col>{/* <label style={footerTitle}>Platform</label> */}</Col>
        </Row>
        <Row>
          <Col>
            <img src={Logo} width={150} alt="Only Ryan by WallOf logo" />
            <label style={{ margin: "0px 0px", textAlign: "left" }}>
              Build 2026.VI
            </label>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

const ColStyle: CSSProperties = {
  display: "flex",
  flexFlow: "column",
  textAlign: "start",
  marginBottom: "40px",
};

const footerTitle: CSSProperties = {
  fontWeight: "bold",
  textDecoration: "underline",
};

export { Footer };
